import {
    apiRequest,
    riwayatpenugasanDetail
} from "../../../../../services/adapters/kepegawaian/riwayatpenugasanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatpenugasanDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository